import cn from 'classnames';
import styles from './DocumentLink.module.scss';

type DocumentLinkProps = {
  className?: string;
  title: string;
  link: string;
};

export function DocumentLink({ className, title, link }: DocumentLinkProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <a
      className={wrapperClassName}
      href={link}
      target="_blank"
      rel="noreferrer"
    >
      <span className={styles.text}>{title}</span>
      <img className={styles.icon} alt="document" src="/svg/file-red.svg" />
    </a>
  );
}
